/* istanbul ignore file */
/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import { Card } from 'react-bootstrap';
import ReadingDisplay from '../common/ReadingDisplay';
import CardHeader from '../common/CardHeader';
import CardStatusBar from '../common/CardStatusBar';

const FourReadingCard = ({
  sensorName,
  typeName,
  macAddress,
  lastUpdated,
  reading1 = {
    title: 'Unknown', value: 0, units: '', isTriggered: null, channelKey: '',
  },
  reading2 = {
    title: 'Unknown', value: 0, units: '', isTriggered: null, channelKey: '',
  },
  reading3 = {
    title: 'Unknown', value: 0, units: '', isTriggered: null, channelKey: '',
  },
  reading4 = {
    title: 'Unknown', value: 0, units: '', isTriggered: null, channelKey: '',
  },
  isHub = false,
  rssi = 0,
  isWireless,
  onSettingsClick,
  batteryLevel = 0,
  generalAlerts = [],
  isPluggedIn = false,
  isMuted = false,
}) => (
  <div style={isMuted ? { opacity: 0.5 } : {}}>
    <Card style={{
      width: '16rem', height: '16rem', borderRadius: '10px', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    }}
    >
      {/* eslint-disable-next-line max-len */}
      <CardHeader
        sensorName={sensorName}
        macAddress={macAddress}
        typeName={typeName}
        onSettingsClick={onSettingsClick}
        lastUpdated={lastUpdated}
        isMuted={isMuted}
      />
      <CardStatusBar
        rssi={rssi}
        isWireless={isWireless}
        isHub={isHub}
        batteryLevel={batteryLevel}
        generalAlerts={generalAlerts}
        isPluggedIn={isPluggedIn}
      />
      <Card.Body style={{
        padding: '0.5rem',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: 'calc(100% - 2.5rem)',
      }}
      >
        <Card
          className="h-100"
          style={{
            borderRadius: '10px',
            borderColor: '#d3d3d3',
          }}
        >

          <div
            className="d-flex justify-content-center pb-2 pt-1"
            style={{ height: '50%', borderBottom: '1px solid #d3d3d3' }}
          >
            <div style={{ flex: '1', borderRight: '1px solid #d3d3d3' }}>
              <ReadingDisplay {...reading1} size="small" />
            </div>

            <div style={{ flex: '1' }}>
              <ReadingDisplay {...reading2} size="small" />
            </div>
          </div>

          <div className="d-flex align-items-center justify-content-center pt-1" style={{ height: '50%' }}>
            <div style={{ flex: '1', borderRight: '1px solid #d3d3d3' }}>
              <ReadingDisplay {...reading3} size="small" />
            </div>

            <div style={{ flex: '1' }}>
              <ReadingDisplay {...reading4} size="small" />
            </div>

          </div>
        </Card>
      </Card.Body>
    </Card>
  </div>
);
FourReadingCard.propTypes = {
  sensorName: PropTypes.string.isRequired,
  typeName: PropTypes.string.isRequired,
  macAddress: PropTypes.string.isRequired,
  lastUpdated: PropTypes.string.isRequired,
  reading1: PropTypes.shape({
    title: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]).isRequired,
    units: PropTypes.string.isRequired,
    isTriggered: PropTypes.bool || null,
  }),
  reading2: PropTypes.shape({
    title: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]),
    units: PropTypes.string.isRequired,
    isTriggered: PropTypes.bool || null,
  }).isRequired,
  reading3: PropTypes.shape({
    title: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]),
    units: PropTypes.string.isRequired,
    isTriggered: PropTypes.bool || null,
  }).isRequired,
  reading4: PropTypes.shape({
    title: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]).isRequired,
    units: PropTypes.string.isRequired,
    isTriggered: PropTypes.bool || null,
  }),
  isHub: PropTypes.bool,
  rssi: PropTypes.number,
  isWireless: PropTypes.bool.isRequired,
  batteryLevel: PropTypes.number,
  onSettingsClick: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  generalAlerts: PropTypes.array,
  isPluggedIn: PropTypes.bool,
  isMuted: PropTypes.bool,
};

export default FourReadingCard;
